import { CapoPlugin } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];